import PageLayout from '@frolight/components/PageLayout';
import TableOfContents from '@frolight/components/TableOfContents';
import usePageTitle from '@frolight/hooks/usePageTitle';
import Panel from '@frolight/components/Panel';
import useFormattedLocalizedText from '@frolight/hooks/useLocalizedFormattedText';

const TermsOfUse = () => {
  const { lftext } = useFormattedLocalizedText();

  const title = lftext('pages.terms_of_use.title');

  usePageTitle(title);

  return (
    <PageLayout>
      <Panel
        size="huge"
        title={ <h1>{ title }</h1> }
      >
        <main>
        <p>
            {lftext('pages.terms_of_use.effective_as_of')}
          </p>
          <TableOfContents >
            <div>
              {lftext('pages.terms_of_use.content')}
            </div>
          </TableOfContents>
        </main>
      </Panel>
    </PageLayout>
  );

}

export default TermsOfUse;